import { Link } from "react-router-dom";

// Shared between PolicyUpdateModal and the signup consent copy — a plain
// list of links to whichever policies are currently required, driven by
// the same `requiredPolicies`/registry shape both call sites already have.
// Not the modal itself reused inside signup (different UX), just this.
export default function PolicyLinks({ policies }) {
  if (!policies?.length) return null;
  return (
    <ul className="policy-links-list">
      {policies.map((policy) => (
        <li key={policy.documentType}>
          <Link to={policy.path} target="_blank" rel="noopener noreferrer" className="account-inline-link">
            {policy.title}
          </Link>
        </li>
      ))}
    </ul>
  );
}
